var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66667 1.66665V0.99998C8.66667 0.633313 8.96667 0.333313 9.33333 0.333313C9.7 0.333313 10 0.633313 10 0.99998V1.66665H10.6667C11.4 1.66665 12 2.26665 12 2.99998V12.3333C12 13.0666 11.4 13.6666 10.6667 13.6666H1.33333C0.593333 13.6666 0 13.0666 0 12.3333L0.00666667 2.99998C0.00666667 2.26665 0.593333 1.66665 1.33333 1.66665H2V0.99998C2 0.633313 2.3 0.333313 2.66667 0.333313C3.03333 0.333313 3.33333 0.633313 3.33333 0.99998V1.66665H8.66667ZM2 12.3333H10C10.3667 12.3333 10.6667 12.0333 10.6667 11.6666V4.99998H1.33333V11.6666C1.33333 12.0333 1.63333 12.3333 2 12.3333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 11.3333C14.6667 13.7266 12.7266 15.6667 10.3333 15.6667C7.9401 15.6667 6 13.7266 6 11.3333C6 8.9401 7.9401 7 10.3333 7C12.7266 7 14.6667 8.9401 14.6667 11.3333Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 9C10.1723 9 10.0417 9.13058 10.0417 9.29167V11.0417H8.29167C8.13058 11.0417 8 11.1723 8 11.3333C8 11.4944 8.13058 11.625 8.29167 11.625H10.0417V13.375C10.0417 13.5361 10.1723 13.6667 10.3333 13.6667C10.4944 13.6667 10.625 13.5361 10.625 13.375V11.625H12.375C12.5361 11.625 12.6667 11.4944 12.6667 11.3333C12.6667 11.1723 12.5361 11.0417 12.375 11.0417H10.625V9.29167C10.625 9.13058 10.4944 9 10.3333 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPlus);
export default __webpack_public_path__ + "static/media/calendar-plus.2043cb8c67c6e96f23edf74cd9ac1103.svg";
export { ForwardRef as ReactComponent };